import { styled } from "@mui/material/styles";
import { Button, Dialog, CircularProgress, Typography, Paper } from "@mui/material";

import SpinningCloseButton from "components/SpinningCloseButton";
import HTMLPlayer from "components/HTMLPlayer";
import { getOccasionKeyByValue } from "utils/relativeUtils";

export const StyledDialog = styled(Dialog)(({ theme, dateType }) => {
  const occasionKey = getOccasionKeyByValue(dateType);
  const occasionBackground = occasionKey
    ? { background: theme.palette.calendarRelations[occasionKey]?.background }
    : {};

  return {
    "& .MuiDialog-container": occasionBackground,
  };
});

export const StyledPaper = styled(Paper)(({ theme }) => ({
  "&.MuiPaper-root": {
    position: "relative",
    padding: "0 20px 0 20px",
    overflow: "initial",
    color: theme.palette.common.white,
    minWidth: 255,
    minHeight: 100,
    width: "85%",
    backgroundColor: "white",
    [theme.breakpoints.up("tablet")]: {
      padding: "60px 80px 60px 80px",
      width: "auto",
    },
  },
}));

export const Container = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  textAlign: "center",
  [theme.breakpoints.up("tablet")]: {
    flexDirection: "row",
    alignItems: "flex-start",
  },
}));

export const StyledSpinningCloseButton = styled(SpinningCloseButton)({
  transform: "translate(50%, -50%)",
});

export const Info = styled("section")(({ theme }) => ({
  marginTop: 30,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  [theme.breakpoints.up("tablet")]: {
    maxWidth: 370,
    position: "relative",
  },
}));

export const Actions = styled("section")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  [theme.breakpoints.up("tablet")]: {
    position: "relative",
    marginLeft: 100,
    padding: 0,
  },
}));

export const Video = styled(HTMLPlayer)({
  objectFit: "cover",
});

export const PlayerContainer = styled("section")(({ theme }) => ({
  overflow: "hidden",
  borderRadius: 10,
  boxShadow: "0px 0px 15px rgb(0 0 0 / 20%)",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  height: "auto",
  [theme.breakpoints.up("mobile")]: {
    width: 500,
    margin: "auto",
    maxWidth: 500,
  },
  [theme.breakpoints.up("tablet")]: {
    maxWidth: 500,
  },
}));

export const PlayerActions = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "15px 20px",
  height: "auto",
  [theme.breakpoints.up("tablet")]: {
    height: "auto",
  },
}));

export const TextContent = styled("div")({
  margin: "26px auto",
});

export const Title = styled(Typography)({
  marginBottom: 15,
});

export const Text = styled(Typography)({
  marginTop: 12,
});

export const Buttons = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  margin: "15px auto",
  "@media screen and (max-height: 700px) and (max-width: 600px)": {
    width: "100%",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  [theme.breakpoints.up("mobile")]: {
    flexDirection: "row",
    margin: "30px auto",
  },
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  width: 190,
  [theme.breakpoints.up("mobile")]: {
    width: 240,
  },
  "@media screen and (max-height: 700px) and (max-width: 600px)": {
    fontSize: theme.typography.pxToRem(12),
    padding: "10px 5px",
    margin: 0,
    width: 125,
  },
  margin: "5px 10px",
}));

export const ButtonEdit = styled(Button)(({ theme }) => ({
  display: "block",
  position: "relative",
  margin: 0,
  padding: 0,
  width: 61,
  height: 26,
  fontSize: theme.typography.pxToRem(12),
}));

export const ButtonProgress = styled(CircularProgress)({
  position: "absolute",
  top: "50%",
  left: "50%",
  marginTop: -12,
  marginLeft: -12,
});

export const ButtonOrder = styled(StyledButton)(({ theme }) => ({
  order: 2,
  [theme.breakpoints.up("mobile")]: {
    order: 1,
  },
  "@media screen and (max-height: 700px) and (max-width: 600px)": {
    order: 1,
  },
}));

export const Schedule = styled(StyledButton)(({ theme }) => ({
  order: 1,
  [theme.breakpoints.up("mobile")]: {
    order: 2,
  },
  "@media screen and (max-height: 700px) and (max-width: 600px)": {
    order: 2,
  },
}));
